import { useTranslation } from "react-i18next";

const ExchangeRefundPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="h-auto w-full flex flex-col gap-5">
      <h1 className="uppercase text-4xl font-bold drop-shadow-xl">
        {t("policy.exchange_refund.title")}
      </h1>
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-bold">
            {t("policy.exchange_refund.scope_of_application")}
          </h2>
          <p className="text-justify">
            {t("policy.exchange_refund.scope_description")}
          </p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-bold">
            {t("policy.exchange_refund.definitions")}
          </h2>
          <p className="">{t("policy.exchange_refund.e_visa")}</p>
          <p className="">{t("policy.exchange_refund.application")}</p>
          <p className="">{t("policy.exchange_refund.processing_time")}</p>
          <div className="flex flex-col gap-5 italic">
            <h2 className="font-bold text-xl">
              {t("policy.exchange_refund.note")}
            </h2>
            <p className="">{t("policy.exchange_refund.note_description")}</p>
            <p className="">{t("policy.exchange_refund.refund_note")}</p>
          </div>
        </div>
        {/* Cancellation and refund */}
        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-bold">
            {t("policy.exchange_refund.cancellation_title")}
          </h2>
          <p>
            If an order is incomplete and not canceled within ninety (90) days,
            a credit may be applied toward a future order within six (6) months
            of the original order date.
          </p>
          <p>{t("policy.exchange_refund.rejection_refund")}</p>
          <p>{t("policy.exchange_refund.bank_charges")}</p>
          <p>{t("policy.exchange_refund.cancel_before_payment")}</p>
          <p>{t("policy.exchange_refund.cancel_before_processing")}</p>
          <p>{t("policy.exchange_refund.cancel_after_processing")}</p>
          <p>{t("policy.exchange_refund.correction_fee")}</p>
          <p>{t("policy.exchange_refund.processing_notification")}</p>
          <p>{t("policy.exchange_refund.no_refund_after_issue")}</p>
          <p>{t("policy.exchange_refund.document_delivery")}</p>
          <p>{t("policy.exchange_refund.expedite_fee")}</p>
          <p>{t("policy.exchange_refund.contact_for_delay")}</p>
          <p>{t("policy.exchange_refund.technical_problems")}</p>
          <p>{t("policy.exchange_refund.no_liability")}</p>
          <p>{t("policy.exchange_refund.double_check")}</p>
          <p>{t("policy.exchange_refund.non_refundable_tickets")}</p>
          <p>{t("policy.exchange_refund.admin_fee")}</p>
          <p>{t("policy.exchange_refund.company_mistake")}</p>
          <p>{t("policy.exchange_refund.refund_schedule")}</p>
        </div>

        {/* <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-bold">
            {t("policy.exchange_refund.specific_regulations")}
          </h2>
          <div className="flex flex-col gap-5 text-justify">
            <p className="text-xl font-semibold">
              {t("policy.exchange_refund.visa_changes")}
            </p>
            <p className="">
              {t("policy.exchange_refund.visa_change_description")}
            </p>
            <p className="">
              {t("policy.exchange_refund.visa_change_request")}
            </p>
            <p className="">
              {t("policy.exchange_refund.visa_support_contact")}
            </p>
          </div>
          <div className="flex flex-col gap-5 text-justify">
            <p className="text-xl font-semibold">
              {t("policy.exchange_refund.refund_policy")}
            </p>
            <p className="">{t("policy.exchange_refund.refund_eligibility")}</p>
            <p className="">
              {t("policy.exchange_refund.refund_request_timeline")}
            </p>
          </div>
          <div className="flex flex-col gap-5 text-justify">
            <p className="text-xl font-semibold">
              {t("policy.exchange_refund.service_issues")}
            </p>
            <p className="">
              {t("policy.exchange_refund.service_issues_description")}
            </p>
            <p className="">
              {t("policy.exchange_refund.service_refund_timeline")}
            </p>
          </div>
          <ul className="flex flex-col gap-5 text-justify">
            <p className="text-xl font-semibold">
              {t("policy.exchange_refund.refund_procedure")}
            </p>
            <div className="">
              <span className="inline-block mr-2">
                {t("policy.exchange_refund.refund_step_1")}
              </span>
            </div>
            <li className="">
              <span className="inline-block mr-2">
                {t("policy.exchange_refund.refund_step_2")}
              </span>
            </li>
          </ul>
        </div> */}
      </div>
    </div>
  );
};

export default ExchangeRefundPolicy;
